import { useLang } from '../i18n'

const CONTACT_EMAIL = 'contact@ubigym.ma'
const color = '#10b981'

export default function HowItWorks() {
  const { t } = useLang()
  const h = t.howItWorks

  return (
    <section id="how" style={{ background: '#0a0a0a', padding: '100px 24px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 64 }}>
          <p style={{ color, fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 12px' }}>{h.eyebrow}</p>
          <h2 style={{ color: 'white', fontSize: 'clamp(1.8rem,3vw,2.8rem)', fontWeight: 900, margin: 0, letterSpacing: '-0.5px' }}>{h.title}</h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 24, marginBottom: 64 }}>
          {h.steps.map((s, i) => (
            <div key={s.num} style={{ position: 'relative' }}>
              {i < h.steps.length - 1 && (
                <div style={{ position: 'absolute', top: 22, left: 'calc(100% - 12px)', width: '24px', height: 1, background: 'rgba(255,255,255,0.08)', zIndex: 0 }} className="step-arrow" />
              )}
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '28px 22px', height: '100%' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderRadius: 10, background: `${color}18`, border: `1px solid ${color}30`, marginBottom: 18 }}>
                  <span style={{ color, fontWeight: 900, fontSize: 14 }}>{s.num}</span>
                </div>
                <h3 style={{ color: 'white', fontSize: 16, fontWeight: 700, margin: '0 0 10px' }}>{s.title}</h3>
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, lineHeight: 1.65, margin: 0 }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ background: `linear-gradient(135deg, ${color}18, ${color}08)`, border: `1px solid ${color}25`, borderRadius: 20, padding: '48px 40px', textAlign: 'center' }}>
          <h3 style={{ color: 'white', fontSize: 'clamp(1.4rem,2.5vw,2rem)', fontWeight: 800, margin: '0 0 12px', letterSpacing: '-0.3px' }}>
            {h.ctaTitle}
          </h3>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 16, margin: '0 0 28px' }}>{h.ctaDesc}</p>
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 32px', borderRadius: 10, background: color, color: 'white', fontWeight: 700, fontSize: 15, textDecoration: 'none' }}>
            {h.ctaBtn}
          </a>
        </div>
      </div>

      <style>{`@media (max-width: 768px) { .step-arrow { display: none !important; } }`}</style>
    </section>
  )
}
